<template>
  <v-autocomplete
      outlined
      @change="selectOrderInAutocomplete"
      :items="findedOrders"
      :loading="isFindingOrders"
      clearable
      hide-no-data
      hide-selected
      :item-text="orderAutocompleteItemText"
      :search-input.sync="findOrderString"
      :label="label"
      :placeholder="placeholder"
      prepend-inner-icon="mdi-database-search"
      return-object
  ></v-autocomplete>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import CommonMixin from "@/mixins/common";

export default {
  name: "OrderSearchInput",
  props: {
    placeholder: String,
    label: String
  },
  mixins: [CommonMixin],
  data: () => ({
    findTimeoutId: null,
    selected: null,
  }),
  computed: {
    ...mapFields("orders", ["findOrderString", "isFindingOrders", "findedOrders"]),
  },
  methods: {
    orderAutocompleteItemText(item) {
      let date = this.$moment(item.created_at).format("DD.MM.YYYY HH:mm");
      return `#${item.human_number} (${this.formatCurrency(item.total_sum)})
      ${item.customer.last_name} ${item.customer.first_name} ${
          item.customer.patronymic ? item.customer.patronymic : ""
      }
      [${date}]`;
    },
    selectOrderInAutocomplete(order) {
      this.selected = order;
      this.findOrderString = null;
      if(order) {
        this.$emit('select', order)
      }
    }
  },
  watch: {
    findOrderString() {
      if(this.selected && this.orderAutocompleteItemText(this.selected) === this.findOrderString){
        clearTimeout(this.findTimeoutId);
        return;
      }
      if(this.findOrderString === '' || this.findOrderString === null) {
        clearTimeout(this.findTimeoutId);
        return;
      }
      clearTimeout(this.findTimeoutId);
      this.findTimeoutId = setTimeout(() => {
        this.$store.dispatch("orders/find", {
          sortBy: "human_number",
          sortDesc: "false",
        });
      }, 1000);
    },
  }
}
</script>

<style scoped>

</style>